// extracted by mini-css-extract-plugin
export default {"cell":"AutoContinueCell_cell__5Ia3I","status":"AutoContinueCell_status__rjcqD"};